<section class="contact-highlight">

    <div class="container-redesign">

        <div class="contact-highlight__grid">

            <div class="contact-highlight__content">

                <h2 class="contact-highlight__title">
                    {{ title }}
                </h2>

                <p class="contact-highlight__description">
                    {{ description }}
                </p>

                <a
                    routerLink="/contact-redesign"
                    class="cta-banner__button cta-banner__button--primary">

                    <span>TALK TO OUR TEAM</span>

                    <img
                        src="/assets/img/redesign/flecha.svg"
                        alt=""
                        class="cta-banner__button-icon">

                </a>

            </div>

            <div class="contact-highlight__cards">

                <article
                    *ngFor="let card of cards; trackBy: trackByTitle"
                    class="contact-highlight__card">

                    <img
                        [src]="card.icon"
                        [alt]="card.title"
                        class="contact-highlight__icon">

                    <h3 class="contact-highlight__card-title">

                        {{ card.title }}

                    </h3>

                    <p
                        *ngFor="let line of card.lines; trackBy: trackByIndex"
                        class="contact-highlight__line">

                        {{ line }}

                    </p>

                </article>

            </div>

        </div>

    </div>

</section>